export const ROUTE_PRINT_BILLET = '/api/boleto/ver';
